//-- Copyright (c) 2021 TMT Insights Group, LLC
import { selectAllLanguages, selectAudioLanguages, selectBaseLanguages, selectSubtitlesLanguages } from '@/redux/selectors/constantsSelectors';
import { Typography } from '@mui/material';
import { useAppSelector } from '@/redux/hooks';
import { useMemo } from 'react';

export interface LanguageListProps {
  codes: string[];
  type: 'audio' | 'subtitle' | 'base' | 'all';
}

const CSVLanguages = (props: LanguageListProps) => {
  const { codes, type } = props;
  const filteredCodes = useMemo(() => codes.filter(Boolean), [codes]);
  const allLanguages = useAppSelector(selectAllLanguages);
  const audioLanguages = useAppSelector(selectAudioLanguages);
  const baseLanguages = useAppSelector(selectBaseLanguages);
  const subtitleLanguages = useAppSelector(selectSubtitlesLanguages);

  const langList = useMemo(() => {
    switch (type) {
      case 'all':
        return allLanguages || [];
      case 'audio':
        return audioLanguages || [];
      case 'subtitle':
        return subtitleLanguages || [];
      case 'base':
      default:
        return baseLanguages || [];
    }
  }, [type, allLanguages, audioLanguages, baseLanguages, subtitleLanguages]);

  if (filteredCodes.length === 0) return '-';

  return (
    <Typography>
      {filteredCodes.map((lac: string) => langList?.find((l) => lac && [lac, lac.replace('-', '_')].includes(l.code))?.label || lac).join(', ')}
    </Typography>
  );
};
export default CSVLanguages;
